export default __webpack_public_path__ + "static/media/alignment-top.5e641388.svg";